import React from 'react'
import PropTypes from 'prop-types'

const DnsLookupButton = ({ violation, style = {} }) => {
	const domain = violation && violation.domain
	if (!domain) return null

	let url = `https://www.whois.com/whois/${domain}`
	let isFR = false

	if (domain.endsWith('.be')) {
		url = `https://www.dnsbelgium.be/nl/whois/info/${domain}/details`
	} else if (domain.endsWith('.nl')) {
		url = `https://www.sidn.nl/whois/?q=${domain}/details`
	} else if (domain.endsWith('.fr')) {
		url = `https://www.eurodns.com/`
		isFR = true
	} else if (domain.endsWith('.eu')) {
		url = `https://whois.eurid.eu/en/search/?domain=${domain}`
	}

	const handleClick = (e) => {
		e.preventDefault()
		if (isFR && navigator.clipboard) {
			navigator.clipboard.writeText(domain)
		}
		window.open(url, '_blank', 'noopener,noreferrer')
	}

	const defaultStyle = {
		color: '#3b82f6',
		textDecoration: 'underline',
		cursor: 'pointer',
		...style
	}

	return (
		<a
			href={isFR ? '#' : url}
			onClick={isFR ? handleClick : undefined}
			target={isFR ? undefined : '_blank'}
			rel={isFR ? undefined : 'noopener noreferrer'}
			style={defaultStyle}
		>
			DNS Lookup{isFR ? ' (copied)' : ''}
		</a>
	)
}

DnsLookupButton.propTypes = {
	violation: PropTypes.shape({
		domain: PropTypes.string,
	}).isRequired,
	style: PropTypes.object,
}

export default DnsLookupButton
